var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cms-post-content-block" }, [
    !_vm.injectedBlocks || _vm.injectedBlocks.length === 0
      ? _c(
          "div",
          { staticClass: "cms-post-content-block__placeholder" },
          [_vm._t("default")],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }